module.exports = __webpack_public_path__ + "img/arcoiris-roll.67e883ef.jpg";